import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { IntlActions, withTranslate } from 'react-redux-multilingual';
import Modal from '../../components/Modal/Modal';
import * as UserActions from '../../reducers/UserReducer/UserActions';

import Login from '../../components/Login/Login';
import Register from '../../components/Register/Register';

import './Topbar.scss';

class TopBar extends Component {

  constructor(props) {
    super(props);
    this.changeLanguage = this.changeLanguage.bind(this);
    this.logout = this.logout.bind(this);
    this.showLoginModal = this.showLoginModal.bind(this);
    this.showRegisterModal = this.showRegisterModal.bind(this);
    this.closeLoginModal = this.closeLoginModal.bind(this);
    this.closeRegisterModal = this.closeRegisterModal.bind(this);
  }

  changeLanguage(e) {
    localStorage.setItem('locale', e.target.value);
    this.props.dispatch(IntlActions.setLocale(e.target.value));
  }

  logout() {
    const { dispatch } = this.props;
    dispatch(UserActions.logoutUserCreator());
  }

  showLoginModal() {
    const { dispatch } = this.props;
    dispatch(UserActions.showLoginModal());
  }

  showRegisterModal() {
    const { dispatch } = this.props;
    dispatch(UserActions.showRegisterModal());
  }

  closeLoginModal() {
    const { dispatch } = this.props;
    dispatch(UserActions.closeLoginModal());
  }

  closeRegisterModal() {
    const { dispatch } = this.props;
    dispatch(UserActions.closeRegisterModal());
  }

  render() {
    const validUser = this.props.user.authentication.valid;
    const { translate, user } = this.props;

    return (<div>
        <div className="topbar-container">
          <div className="container">

          <Link to="/">
            <span className="logo" />
          </Link>

            <select className="lang" onChange={this.changeLanguage}>
              <option value="en">EN</option>
              <option value="he">HE</option>
            </select>

          <div className="topbar-menu">

            {validUser && <div className="left">
              <Link to="/user/booking-history">
                Booking History
              </Link>
              <span className="item" onClick={this.logout}>{translate('common.logout')}</span>
              <Link to="/profile">
                <span className="username">
                  {this.props.user.information.name}
                </span>
              </Link>
            </div>}

            {!validUser && <div className="left">
              <div onClick={this.showRegisterModal}>
                {translate('common.register')}
              </div>
              <div onClick={this.showLoginModal}>
                {translate('common.login')}
              </div>
            </div>}
            </div>
          </div>
        </div>
          <Modal show={user.showLoginModal} close={this.closeLoginModal} component={Login} />
          <Modal show={user.showRegisterModal} close={this.closeRegisterModal} component={Register} />
        </div>
    );
  }
}


TopBar.defaultProps = {
    user: {
      authentication: {
        vaid: false,
      },
    },
    translate: () => {},
    dispatch: () => {},
};

TopBar.propTypes = {
    user: React.PropTypes.object,
    dispatch: React.PropTypes.func,
    translate: React.PropTypes.func,
};


const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps)(withTranslate(TopBar));




// WEBPACK FOOTER //
// ./src/containers/Topbar/Topbar.js